<template>
  <div>
    <!-- 实时数据 -->
    <!--<AlarmViewNav></AlarmViewNav>-->
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>警报点</el-breadcrumb-item>
        <el-breadcrumb-item>动态数据</el-breadcrumb-item>
        <el-breadcrumb-item>实时数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="display: flex; flex-direction: column; ">
      <div id="titleMsg" style="display: block; margin-bottom: 10px;float: right">
        <span>通信终端:{{this.DTUonline}}</span>
        <span v-if="showMore==true" style="margin-left: 40px">通信终端上传时间:{{this.DTUtime}}</span>
        <span v-if="showMore==true" style="margin-left: 40px">ICCID:{{this.ICCID}}</span>
        <!--        <span v-if="showMore==true" style="margin-left: 80px">监测设备上传时间:{{this.MCUtime}}</span>-->
        <span v-if="showMore==true" style="margin-left:20px;text-decoration: underline;color: #20a0ff;cursor: pointer" @click="showMore=!showMore">返回</span>
        <span v-if="showMore==false" style="margin-left:20px;text-decoration: underline;color: #20a0ff;cursor: pointer" @click="showMore=!showMore">显示更多</span>
        <i class="el-icon-question" style="float:right;font-size: 20px;cursor: pointer" title="传感器介绍" @click="dialogVisible=true"></i>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          v-if="dialogVisible"
        >
          <span>这是一段信息</span>
          <span slot="footer" class="dialog-footer">
  </span>
        </el-dialog>
        <div style="margin-top:10px">
          <span><el-button type="primary" @click="tcpSend" size="small">手动获取数据</el-button></span>
        </div>

        <!--        <el-button type="primary" @click="getDynamicData(true)" size="mini" style="position: relative;" >刷新</el-button>-->
      </div>
      <div>
        <el-card style="margin-top: 10px">
          <div style="display: flex;flex-direction: column">
            <div class="cardTitle" style="margin-bottom: -30px;">
              <div style="background-color: #ff9900"><span>供电情况</span></div>
            </div>
            <div class="cardLine">
              <div class="dataItem" v-for="value in powerSupply">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;"><span>{{value.name}}</span></div>
                </div>
                <div>
                  <span style="font-size: 20px;margin-left: 20px;color: red"
                        v-if="value.flag==true">{{value.value}}</span>
                  <span style="font-size: 20px;margin-left: 20px;"
                        v-if="value.flag==false||!value.flag">{{value.value}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div>
        <el-card style="margin-top: 10px">
          <div style="display: flex;flex-direction: column">
            <div class="cardTitle" style="margin-bottom: -30px;">
              <div style="background-color: #ff9900"><span>设备状态</span></div>
            </div>
            <div class="cardLine">
              <div class="dataItem" v-for="value in equipmentState">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;">{{value.name}}</div>
                </div>
                <div>
                  <span style="font-size: 20px;margin-left: 20px;">{{value.value}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div>
        <el-card style="margin-top: 10px">
          <div style="display: flex;flex-direction: column">
            <div class="cardTitle" style="margin-bottom: -30px;">
              <div style="background-color: #ff9900"><span>环境参数</span></div>
            </div>
            <div class="cardLine">
              <div class="dataItem" v-for="value in environmentalParam">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;">{{value.name}}</div>
                </div>
                <div>
                  <span style="font-size: 20px;margin-left: 20px;color: red"
                        v-if="value.flag==true">{{value.value}}</span>
                  <span style="font-size: 20px;margin-left: 20px;"
                        v-if="value.flag==false||!value.flag">{{value.value}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div>
        <el-card style="margin-top: 10px">
          <div style="display: flex;flex-direction: column">
            <div class="cardTitle" style="margin-bottom: -30px;">
              <div style="background-color: #ff9900"><span>摄像头</span></div>
            </div>
            <div class="cardLine">
              <div class="dataItem" v-for="value in cameraStat">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;">{{value.name}}</div>
                </div>
                <div>
                  <span style="font-size: 20px;margin-left: 20px;color: red"
                        v-if="value.flag==true">{{value.value}}</span>
                  <span style="font-size: 20px;margin-left: 20px;"
                        v-if="value.flag==false||!value.flag">{{value.value}}</span>
                </div>
              </div>
              <div class="dataItem" v-if="this.cameraNum == '1-1'||this.cameraNum=='2'">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;">室内摄像头</div>
                </div>
                <div style="margin-left: 10px;margin-top: 10px">
                  <el-button type="primary" size="medium" @click="gotoMonitorIndoor()">实时监控</el-button>
                </div>
              </div>
              <div class="dataItem" v-if="this.cameraNum == '1-2'||this.cameraNum=='2'">
                <div style="display: flex;margin-top: 35px">
                  <div
                    style="background-color: #facc14;;height: 10px;width: 10px;margin-right: 10px;border-radius: 5px"></div>
                  <div style="font-size: 20px;">室外摄像头</div>
                </div>
                <div style="margin-left: 10px;margin-top: 10px">
                  <el-button type="primary" size="medium" @click="gotoMonitorOutdoor()">实时监控</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import AlarmViewNav from '../AlarmViewNav'
  import echarts from 'echarts'
  import { eventBus } from '../../../../../bus'

  export default {
    name: 'RealTimeData',
    components: { AlarmViewNav },
    data () {
      return {
        dialogVisible:false,//控制传感器介绍dialog框
        alarmPointId: '',
        url: '',
        isLoading: false,
        showMore:false,//展示更多
        ICCID: '',
        MCUtime: '',
        MCUonline: '',
        DTUtime: '',
        DTUonline: '',
        interval: '',
        devID: '',
        radioInfo: '',
        powerSupply: [],//供电情况集合
        equipmentState: [],//设备状态集合
        environmentalParam: [],//环境参数集合
        cameraStat: [],//摄像头状态
        cameraNum: "0",//此警报点摄像头个数
        isLoading: false,
        isAlarm: false,
        labelPosition: 'left',
        state: '',
        GetStateList: {
          'version': 1,
          'method': 'state.GetPointStateList',
          'params': {
            'pageNumber': 1,
            'alarmPointName': '',
            'areaId': '',
            'alarmPointType': '',
            'onLine': '',
            'voltage1': '',
            'voltage2': '',
            'voltage3': '',
          },
          'token': '#',
          'id': 0
        },
        stateTable: [],
        arrayDate: { name: 'tr', age: '18' },
        voltageDate: {},//三组供电数据
        indoorDate: {},//室内数据数组
        outdoorDate: {},//室外数据数组
        charts: ['', '', '', '', ''],
        dateRange: '',// 时间范围
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        // 获取动态数据
        DynamicData: {
          'version': 1,
          'method': 'alarmpoint2.DynamicDataOne',
          'params': {
            'alarmPointId': '',
            // "startTime":"",
            // "endTime":"",
            // "attribute":""
          },
          'token': '',
          'id': 0
        },
        // 数据列表
        dataList: {
          'version': 1,
          'result': {
            'dataList': [
              {
                'alarmPointId': '',
                'attribute': '',
                'value': '',
                'dataTime': ''
              }
            ]
          },
          'id': ''
        },
        GetsensorList: {
          'version': 1,
          'method': 'sensor.GetSensorValue',
          'params': null,
          'token': '#',
          'id': 0
        },
        getRadioInfo: {
          'version': 1,
          'method': 'radio.GetNewestRadioInfo',
          'params': {
            'devID': ''
          },
          'token': '',
          'id': 0
        },
        //获取摄像头个数
        getCameraList: {
          'version': 1,
          'method': 'camera.GetCameraEzopen',
          'params': {
            'pointName': '',
            'location': '',
            'alarmPointId': '',
            'pageNumber': 1
          },
          'token': '#',
          'id': 0
        },
        GetStaticInformation: {
          'version': 1,
          'method': 'alarmpoint2.GetStaticInformation',
          'params': {
            'alarmPointId': '#'
          },
          'token': '#',
          'id': 0
        },
        sensorList: [],
        tcpSend85: {
          'version': 1,
          'method': 'tcp.TcpSend',
          'params': {
            'devID': '',
            'cmd': '0x85',
            'id': '0x00',
          },
          'token': '#',
          'id': 0
        },
        draw (id, content) {

        },
        test: '',
        tabPosition: 'left',
      }
    },
    methods: {

      saveOneBit (str) {
        str = str + ''
        return str.substring(0, str.indexOf('.') + 2)
      },
      handleDataList () {
        let optionNames = ['声压', '气体', '湿度', '温度', '电压']
        let optionNamesInEng = ['shengya', 'qiti', 'wendu', 'shidu', 'dianya']
        optionNames.forEach((item, index) => {
          let option = {
            title: {
              text: '声压变化历史记录',
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['声压']
            },
            toolbox: {
              show: true,
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar'] },
                restore: { show: true },
                saveAsImage: { show: true }
              }
            },
            calculable: true,
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
              }
            ],
            yAxis: [
              {
                type: 'value',
                axisLabel: {
                  formatter: '{value}'
                }
              }
            ],
            series: [
              {
                name: '声压',
                type: 'line',
                data: [1, 2, 1, 3, 3, 4, 5],
                markPoint: {
                  data: [
                    { name: '最低', value: -2, xAxis: 1, yAxis: -1.5 }
                  ]
                },
                markLine: {
                  data: [
                    { type: 'average', name: '平均值' }
                  ]
                }
              }
            ]
          }
          option.title.text = item + '变化记录'
          option.legend.data = []
          option.legend.data.push(item)
          option.xAxis[0].data = []
          option.series[0].name = item
          option.series[0].data = []
          this.dataList.result.dataList.forEach(item2 => {
            option.xAxis[0].data.push(item2.time)
            option.series[0].data.push(item2[optionNamesInEng[index]])
          })
          console.log(optionNames[index] + '的option')
          console.log(option)
          this.drawChart(this.charts[index], optionNamesInEng[index], option)
        })
      },
      getURL () {
        let url1 = window.location.href
        let index = url1.indexOf('=')
        url1 = url1.substring(index + 1)
        this.url = url1
      },
      getDynamicData () {
        let powerSupply1 = []//供电情况集合
        let equipmentState1 = []//设备状态集合
        let environmentalParam1 = []//环境参数集合
        let cameraStat1 = []//摄像头状态
        this.$axios.post(this.$mainUrl, this.GetsensorList).then(res => {
          if (res.data.hasOwnProperty('result')) {
            let sensorKeyValue = {}//以键值对存储  传感器编号：传感器名称
            for (let i = 0; i < res.data.result.sensorValueList.length; i++) {
              sensorKeyValue[res.data.result.sensorValueList[i].sensorNum] = res.data.result.sensorValueList[i].sensorValue
            }
            this.DynamicData.token = localStorage.getItem('token')
            this.DynamicData.params.alarmPointId = sessionStorage.getItem('alarmPointId')
            this.$axios.post(this.$mainUrl, this.DynamicData).then(res => {
              if (res.data.hasOwnProperty('result')) {
                let allSensorNum = Object.keys(res.data.result)
                for (let i = 0; i < allSensorNum.length; i++) {
                  if (allSensorNum[i] == 34 || allSensorNum[i] == 36 || allSensorNum[i] == 37 || allSensorNum[i] == 38|| allSensorNum[i] == 3) {//如果是供电情况板块的传感器数据
                    let Object1 = {}
                    if (allSensorNum[i] == 36 || allSensorNum[i] == 37 || allSensorNum[i] == 38|| allSensorNum[i] == 3) {
                      if(allSensorNum[i] == 3){
                        Object1.name = "强行上电"
                      }else{
                        Object1.name = sensorKeyValue[allSensorNum[i]]
                      }
                      if (res.data.result[allSensorNum[i]].value == true) {
                        Object1.value = '是'
                      } else {
                        Object1.value = '否'
                      }
                      Object1.flag = res.data.result[allSensorNum[i]].flag
                      powerSupply1.push(Object1)
                    }
                    if (allSensorNum[i] == 34) {
                      Object1.name = sensorKeyValue[allSensorNum[i]]
                      Object1.sensorUnit = res.data.result[allSensorNum[i]].sensorUnit
                      Object1.value = res.data.result[allSensorNum[i]].value + Object1.sensorUnit
                      Object1.flag = res.data.result[allSensorNum[i]].flag
                      powerSupply1.push(Object1)
                    }
                  }
                  //环境参数
                  if (allSensorNum[i] == 0 || allSensorNum[i] == 1 || allSensorNum[i] == 2 || allSensorNum[i] == 32 || allSensorNum[i] == 33 || allSensorNum[i] == 35 || allSensorNum[i] == 39) {
                    let Object2 = {}
                    Object2.name = sensorKeyValue[allSensorNum[i]]
                    Object2.sensorUnit = res.data.result[allSensorNum[i]].sensorUnit
                    Object2.value = res.data.result[allSensorNum[i]].value + Object2.sensorUnit
                    Object2.flag = res.data.result[allSensorNum[i]].flag
                    environmentalParam1.push(Object2)
                  }
                  if (allSensorNum[i] == 40) {//室内图像移动
                    let Object3 = {}
                    Object3.name = sensorKeyValue[allSensorNum[i]]
                    if (res.data.result[allSensorNum[i]].value == true) {
                      Object3.value = '是'
                    } else {
                      Object3.value = '否'
                    }
                    Object3.flag = res.data.result[allSensorNum[i]].flag
                    cameraStat1.push(Object3)
                  }
                  if (allSensorNum[i] == 'MCUonlineFlag') {
                    let Object4 = {}
                    Object4.name = '监测在线'
                    if (res.data.result['MCUonlineFlag'] == true) {
                      Object4.value = '在线'
                    } else {
                      Object4.value = '离线'
                    }
                    equipmentState1.push(Object4)
                  }
                }
                this.powerSupply = powerSupply1
                this.environmentalParam = environmentalParam1
                this.cameraStat = cameraStat1
                let ICCID = res.data.result['ICCID']
                this.ICCID = ICCID
                let MCUtime = res.data.result['MCUtime']
                this.MCUtime = MCUtime
                let DTUtime = res.data.result['DTUtime']
                this.DTUtime = DTUtime
                if (res.data.result['DTUonlineFlag'] == true) {
                  this.DTUonline = '在线'
                } else {
                  this.DTUonline = '离线'
                }
                this.devID = res.data.result['devID']
                //获取到devID后，利用接口调取硬件信息
                this.getRadioInfo.params.devID = this.devID
                this.$axios.post(this.$mainUrl, this.getRadioInfo).then(res => {
                  if (res.data.hasOwnProperty('result')) {
                    this.radioInfo = res.data.result
                    let radioInfoKeys = Object.keys(res.data.result)
                    for (let i = 0; i < radioInfoKeys.length; i++) {
                      let object = {}
                      if (radioInfoKeys[i] == 'radioChannel') {
                        object.name = '信道号';
                        object.value = res.data.result[radioInfoKeys[i]].value
                        equipmentState1.push(object)
                      }
                      if (radioInfoKeys[i] == 'signalStrength') {
                        object.name = '信号强度'
                        object.value = res.data.result[radioInfoKeys[i]].value
                        equipmentState1.push(object)
                      }
                      if (radioInfoKeys[i] == 'frequencyOffset') {
                        object.name = '接收频偏'
                        object.value = res.data.result[radioInfoKeys[i]].value
                        equipmentState1.push(object)
                      }
                      if (radioInfoKeys[i] == 'mistakeSound') {
                        object.name = '异常上报'
                        object.value = res.data.result[radioInfoKeys[i]].value
                        equipmentState1.push(object)
                      }
                    }
                    this.equipmentState = equipmentState1
                  } else {
                    this.$message.error(res.data.error.message)
                  }
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '获取动态列表失败，' + res.data.error.message
                })
              }
            })
          }
        })

      },
      tcpSend () {
        this.tcpSend85.params.devID = this.devID
        this.$axios.post(this.$mainUrl, this.tcpSend85).then(res => {
          if (res.data.hasOwnProperty('result')) {
          }
        })
      },
      cellStyle (value) {
        if (value == '未加电') {
          return 'color:red'
        }
      },

      drawChart (charts, id, option) {
        charts = echarts.init(document.getElementById(id))
        charts.setOption(option)
      },
      gotoMonitorIndoor () {
        this.$router.push('/monitor')
      },
      gotoMonitorOutdoor () {
        this.$router.push('/monitor-outdoor')
      },
      getCameraNum () {//用来判断这个警报点有几个摄像头
        this.getCameraList.params.alarmPointId = sessionStorage.getItem('alarmPointId')
        for (let key in this.getCameraList.params) {
          if (this.getCameraList.params[key] === '') {
            this.getCameraList.params[key] = null
          }
        }

        this.$axios.post(this.$mainUrl, this.getCameraList).then(res => {
          if (res.data.hasOwnProperty('result')) {
            if (res.data.result.ezopenList.length == 1) {
              if(res.data.result.ezopenList[0].location == 1){
                this.cameraNum = "1-1"//只有室内
              }else{
                this.cameraNum = "1-2"//只有室外
              }
            }
            else  if (res.data.result.ezopenList.length == 2) {
              this.cameraNum = "2";
            }
            else {
              this.cameraNum = "0";
            }
          }
        })
      }
    },
    watch: {
      dateRange (newValue, oldValue) {
        if (newValue === '' || newValue === null) {
          this.DynamicData.params.startTime = null
          this.DynamicData.params.endTime = null
        }
        this.DynamicData.params.startTime = newValue[0]
        this.DynamicData.params.endTime = newValue[1]
      }
    },
    created () {
      this.getCameraNum()
      this.getDynamicData()
      //this.getSensorList()
      //this.getDynamicData();

      // eventBus.$on('id', (val)=> { //Hub接收事件
      //   alert(val)
      //   this.alarmPointId = val;
      // });
      //this.$router.push( {path: '/realTimeData', query: {alarmPointId: 16}})
      // this.getDynamicData(true);
      // this.$store.commit('setAlarmPointID1',this.$route.query.alarmPointId)

      this.interval = setInterval(() => {
        this.getDynamicData()
      }, 2000)
      // this.drawChart(this.voltageCharts,'voltage',this.voltageOption);
      // this.drawChart(this.soundPressureCharts,'soundPressure',this.soundPresureOption)
      // this.drawChart(this.humidityCharts,'humidity',this.humidityOption)
      // this.drawChart(this.temperatureCharts,'temperature',this.temperatureOption)
      // this.drawChart(this.gasCharts,'gas',this.gasOption)

    },
    destroyed () {
      console.log('定时器已关闭')
      clearInterval(this.interval)
    }
  }
</script>

<style scoped lang="scss">
  .drawCanvas {
    width: 930px;
    height: 400px;
  }

  .flexInner {
    display: flex;
    flex-wrap: nowrap
  }

  .cardTitle {
    width: 100%;
    height: 30px;

    div {
      margin-top: -20px; // el-card默认padding: 20px
      margin-left: -4px; // el-card默认padding: 20px
      width: 80px;
      height: 25px;
      text-align: center;

      span {
        color: black;
        font-family: 黑体;
        /*font-weight: bold;*/
        line-height: 25px;
      }
    }
  }

  .dataItem {
    display: inline-block;
    width: 33%;
    margin-top: 0px
  }

  /*.dataItem {*/
  /*  div:nth-child(1) {*/
  /*    display: flex;*/
  /*    flex-direction: row;*/
  /*    flex-wrap: nowrap;*/
  /*    margin-bottom: 0px;*/
  /*    color: black;*/
  /*    font-size: 16px;*/

  /*    div:nth-child(1) {*/
  /*      width: 10px;*/
  /*      height: 10px;*/
  /*      border-radius: 50%;*/
  /*      margin-top: 7px;*/
  /*      margin-right: 20px;*/
  /*    }*/

  /*    div:nth-child(2) {*/
  /*      width: 150px;*/
  /*      height: 20px;*/
  /*    }*/
  /*  }*/

  /*}*/
  /*.dataItem > div:nth-child(2){*/
  /*  color: black;*/
  /*  width: 100%;*/
  /*  height: 30px;*/
  /*  !*background-color: #20a0ff;*!*/
  /*  font-size: 24px;*/
  /*  margin-left: 20px;*/
  /*  margin-top: 5px;*/
  /*}*/


  /*.dataItem > div > div:nth-child(1){*/
  /*width: 10px;*/
  /*height: 10px;*/
  /*border-radius: 50%;*/
  /*background-color: blue;*/
  /*}*/
  /*.dataItem > div > div:nth-child(2){*/
  /*color: #b4b4b4;*/
  /*}*/

  /*.cardLine{*/
  /*  display: flex;*/
  /*  flex-direction: row;*/
  /*  flex-wrap: nowrap;*/
  /*  justify-content: space-around;*/
  /*}*/
</style>
<style>
  .el-form--inline .el-form-item__label {
    width: 130px;
  }

  .el-form--inline .el-form-item {
    display: flex;
    flex-wrap: nowrap;
  }
</style>
